import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("mhk_lang") || "id");
  const [theme, setTheme] = useState(() => localStorage.getItem("mhk_theme") || "dark");

  useEffect(() => {
    localStorage.setItem("mhk_lang", lang);
  }, [lang]);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("mhk_theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  const t = translations[lang];

  return (
    <SiteContext.Provider value={{ lang, setLang, theme, toggleTheme, t }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => {
  const ctx = useContext(SiteContext);
  if (!ctx) throw new Error("useSite must be used within SiteProvider");
  return ctx;
};
